import type { CalendarAttendee, CalendarProvider, ImportedCalendarEvent } from './types'

export function formatCalendarProvider(provider: string): string {
  if (provider === 'google') return 'Google Calendar'
  if (provider === 'microsoft') return 'Outlook Calendar'
  return provider
}

export function normalizeCalendarProvider(provider: string): CalendarProvider {
  return provider === 'microsoft' ? 'microsoft' : 'google'
}

export function formatCalendarDateTime(value: Date | string): string {
  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date(value))
}

export function formatCalendarTime(value: Date | string): string {
  return new Intl.DateTimeFormat(undefined, {
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date(value))
}

export function getCalendarEventDateKey(value: Date | string): string {
  const date = new Date(value)
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(
    date.getDate()
  ).padStart(2, '0')}`
}

export function getCalendarEventTime(value: Date | string): string {
  const date = new Date(value)
  return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
}

export function parseCalendarAttendees(event: ImportedCalendarEvent): CalendarAttendee[] {
  if (!event.attendeesJson) return []

  try {
    const parsed = JSON.parse(event.attendeesJson)
    return Array.isArray(parsed) ? parsed : []
  } catch {
    return []
  }
}

export function getPrimaryExternalAttendee(event: ImportedCalendarEvent): CalendarAttendee | null {
  return parseCalendarAttendees(event).find((attendee) => attendee.email || attendee.name) ?? null
}

export function getCalendarStateLabel(event: ImportedCalendarEvent): string {
  if (event.syncState === 'conflict') return 'Conflict'
  if (event.managementState === 'managed') return 'Managed'
  if (event.managementState === 'ignored') return 'Ignored'
  if (event.status === 'cancelled') return 'Cancelled'
  return 'Needs details'
}
